import React from "react";

/** Faux browser/app window chrome — wraps every landing mockup. */
export function FauxWindow({ title = "VYAAHAR.APP", children, style, bodyStyle }) {
    return (
        <div className="vy-window" style={style} role="img" aria-label={title.replace(/\s·\s/g, ' — ')}>
            <div className="vy-window-bar" aria-hidden="true">
                <div className="vy-window-dots"><span /><span /><span /></div>
                <div className="vy-window-title">{title}</div>
            </div>
            <div className="vy-window-body" style={bodyStyle}>{children}</div>
        </div>
    );
}

/* ═════════════════ MOCK · DASHBOARD ═════════════════ */
export function MockDashboard() {
    const kpis = [
        { k: "CASH ON HAND", v: "₹12,04,880", d: "+8.4%" },
        { k: "TOTAL AR",     v: "₹1,11,42,000", d: "AR aging: 22d" },
        { k: "TOTAL AP",     v: "₹2,34,120", d: "3 bills due" },
        { k: "GST PAYABLE",  v: "₹1,64,348", d: "3B in 6 days" },
    ];
    return (
        <div style={{ display: "grid", gap: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                <div>
                    <div className="vy-kicker">FYTD · COMMAND CENTER</div>
                    <div className="vy-serif-i" style={{ fontSize: 34, lineHeight: 1.1, marginTop: 4 }}>Net Profit</div>
                    <div className="vy-mono" style={{ fontSize: 30, color: "#1f6c47", marginTop: 6, letterSpacing: -0.5 }}>
                        ₹53,04,120
                    </div>
                </div>
                <div className="vy-mono" style={{ fontSize: 10.5, color: "#6b6258" }}>
                    07 JUL 2026 · 05:56 IST
                </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8 }}>
                {kpis.map((k) => (
                    <div key={k.k} style={{ border: "1px solid #d8d0c2", padding: "10px 12px", borderRadius: 2, background: "#fff" }}>
                        <div className="vy-mono" style={{ fontSize: 8.5, color: "#6b6258", letterSpacing: "0.14em" }}>{k.k}</div>
                        <div className="vy-mono" style={{ fontSize: 13, marginTop: 2, fontWeight: 700 }}>{k.v}</div>
                        <div className="vy-mono" style={{ fontSize: 9, color: "#a68a56", marginTop: 2 }}>{k.d}</div>
                    </div>
                ))}
            </div>
            {/* Fake cash-flow sparkline */}
            <div style={{ background: "#fff", border: "1px solid #d8d0c2", padding: 14, borderRadius: 2 }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div className="vy-mono" style={{ fontSize: 9.5, color: "#6b6258", letterSpacing: "0.14em" }}>CASH FLOW · 12M</div>
                    <div className="vy-mono" style={{ fontSize: 9.5, color: "#1f6c47" }}>+ INFLOW</div>
                </div>
                <svg viewBox="0 0 400 90" style={{ width: "100%", height: 90, marginTop: 6 }}>
                    <path d="M0,70 L40,60 L80,52 L120,58 L160,40 L200,44 L240,28 L280,35 L320,20 L360,25 L400,10"
                        stroke="#a68a56" strokeWidth="2" fill="none" />
                    <path d="M0,70 L40,60 L80,52 L120,58 L160,40 L200,44 L240,28 L280,35 L320,20 L360,25 L400,10 L400,90 L0,90 Z"
                        fill="rgba(166,138,86,0.12)" />
                    <path d="M0,80 L40,76 L80,72 L120,74 L160,68 L200,64 L240,60 L280,58 L320,52 L360,50 L400,44"
                        stroke="#13192e" strokeWidth="1.4" fill="none" strokeDasharray="3,3" />
                </svg>
            </div>
        </div>
    );
}

/* ═════════════════ MOCK · INVOICE ═════════════════ */
export function MockInvoice() {
    const rows = [
        ["Annual Maintenance Contract", "5", "₹1,92,219", "₹9,13,044.71"],
        ["Technical Support · SLA-1",   "1", "₹1,64,348", "₹1,64,348.05"],
    ];
    return (
        <div style={{ padding: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "1px solid #d8d0c2", paddingBottom: 16 }}>
                <div>
                    <div className="vy-kicker">TAX INVOICE</div>
                    <div className="vy-serif" style={{ fontSize: 28, marginTop: 4 }}>INV-00079</div>
                    <div className="vy-mono" style={{ fontSize: 10, color: "#6b6258" }}>$ inv.show --id=INV-00079</div>
                </div>
                <div style={{ textAlign: "right" }}>
                    <div className="vy-mono" style={{ fontSize: 9, color: "#6b6258", letterSpacing: "0.14em" }}>DUE DATE</div>
                    <div className="vy-mono" style={{ fontSize: 13 }}>20 Jun 2026</div>
                </div>
            </div>
            <div style={{ marginTop: 14 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr auto auto auto", gap: 12, fontSize: 11, color: "#6b6258", fontFamily: "IBM Plex Mono, monospace", paddingBottom: 4, borderBottom: "1px solid #eee" }}>
                    <span>DESCRIPTION</span><span>QTY</span><span>RATE</span><span>TOTAL</span>
                </div>
                {rows.map((r, i) => (
                    <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr auto auto auto", gap: 12, fontSize: 12, padding: "8px 0", borderBottom: "1px solid #f4efe4" }}>
                        <span>{r[0]}</span>
                        <span className="vy-mono">{r[1]}</span>
                        <span className="vy-mono">{r[2]}</span>
                        <span className="vy-mono">{r[3]}</span>
                    </div>
                ))}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
                <div style={{ minWidth: 220 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11.5, color: "#6b6258", padding: "4px 0" }}>
                        <span>Subtotal</span><span className="vy-mono">₹10,77,392.76</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11.5, color: "#6b6258", padding: "4px 0" }}>
                        <span>IGST · 18%</span><span className="vy-mono">₹1,64,348.05</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, borderTop: "1px solid #13192e", paddingTop: 8, marginTop: 4 }}>
                        <span className="vy-serif" style={{ fontWeight: 600 }}>Total due</span>
                        <span className="vy-mono" style={{ fontWeight: 700 }}>₹10,77,393.00</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

/* ═════════════════ MOCK · RECONCILIATION ═════════════════ */
export function MockRecon() {
    const rows = [
        { d: "07 JUL", desc: "NEFT · TECHNOPARK SOLUTIONS", amt: "+10,77,393", match: "INV-00079", ok: true },
        { d: "06 JUL", desc: "UPI · JOSHI ENGINEERING",     amt: "+4,50,000",  match: "INV-00074", ok: true },
        { d: "06 JUL", desc: "RAZORPAY PAYOUT · IFN345",    amt: "-2,34,120",  match: "AI · route to 1100", ok: false },
        { d: "05 JUL", desc: "BANK CHARGES",                amt: "-1,180",     match: "AI · route to 6720", ok: false },
    ];
    return (
        <div>
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                <span className="vy-mono" style={{ fontSize: 10, background: "#13192e", color: "#f6f2eb", padding: "6px 12px", borderRadius: 2 }}>HDFC · CURRENT · **1240</span>
                <span className="vy-mono" style={{ fontSize: 10, color: "#6b6258", padding: "6px 12px" }}>UNRECONCILED · 2</span>
                <span className="vy-mono" style={{ fontSize: 10, color: "#1f6c47", padding: "6px 12px" }}>MATCHED · 2</span>
            </div>
            {rows.map((r, i) => (
                <div key={i} style={{ display: "grid", gridTemplateColumns: "auto 1fr auto auto", gap: 12, alignItems: "center", padding: "10px 8px", borderBottom: "1px solid #f4efe4", background: r.ok ? "transparent" : "rgba(166,138,86,0.05)" }}>
                    <span className="vy-mono" style={{ fontSize: 10.5, color: "#6b6258" }}>{r.d}</span>
                    <span style={{ fontSize: 12 }}>{r.desc}</span>
                    <span className="vy-mono" style={{ fontSize: 12, color: r.amt.startsWith("+") ? "#1f6c47" : "#a02c2c", fontWeight: 700 }}>{r.amt}</span>
                    <span className="vy-mono" style={{ fontSize: 10, padding: "3px 8px", background: r.ok ? "rgba(31,108,71,0.1)" : "rgba(166,138,86,0.14)", color: r.ok ? "#1f6c47" : "#a68a56", borderRadius: 2 }}>
                        {r.ok ? "✓ " : "✧ "}{r.match}
                    </span>
                </div>
            ))}
        </div>
    );
}

/* ═════════════════ MOCK · GSTR-2B RECON ═════════════════ */
export function MockGSTR() {
    const rows = [
        { gstin: "27AABCU9603R1ZM", vendor: "AWS INDIA PVT LTD",   inv: "AWS-88214", amt: "42,000.00", status: "MATCH" },
        { gstin: "29AAACR5055K1Z9", vendor: "RAZORPAY",            inv: "RZP-2044",  amt: "1,180.00",  status: "MATCH" },
        { gstin: "33AABCA1234K1Z8", vendor: "CHENNAI POWER CO",    inv: "CPC-889",   amt: "18,400.00", status: "PROBABLE" },
        { gstin: "07AABCV1122B1ZQ", vendor: "VYAAHAR IN 2B ONLY",  inv: "V-9812",    amt: "9,050.00",  status: "IN 2B" },
    ];
    const statusColor = (s) =>
        s === "MATCH" ? { bg: "rgba(31,108,71,0.1)", fg: "#1f6c47" } :
        s === "PROBABLE" ? { bg: "rgba(166,138,86,0.14)", fg: "#a68a56" } :
        { bg: "rgba(160,44,44,0.08)", fg: "#a02c2c" };
    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
                <div>
                    <div className="vy-kicker">GSTR-2B · JUN 2026</div>
                    <div className="vy-serif" style={{ fontSize: 20, marginTop: 4 }}>127 records · 89 matched</div>
                </div>
                <div className="vy-mono" style={{ fontSize: 10, color: "#1f6c47", alignSelf: "flex-end" }}>ITC RECONCILED · ₹4,82,340</div>
            </div>
            <div>
                <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 0.8fr 0.7fr 0.6fr", gap: 8, fontSize: 9.5, color: "#6b6258", fontFamily: "IBM Plex Mono, monospace", paddingBottom: 4, borderBottom: "1px solid #d8d0c2", letterSpacing: "0.14em" }}>
                    <span>VENDOR</span><span>GSTIN</span><span>INV</span><span>AMT</span><span>STATUS</span>
                </div>
                {rows.map((r, i) => {
                    const c = statusColor(r.status);
                    return (
                        <div key={i} style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 0.8fr 0.7fr 0.6fr", gap: 8, alignItems: "center", padding: "8px 0", borderBottom: "1px solid #f4efe4", fontSize: 11.5 }}>
                            <span>{r.vendor}</span>
                            <span className="vy-mono" style={{ fontSize: 10 }}>{r.gstin}</span>
                            <span className="vy-mono" style={{ fontSize: 10 }}>{r.inv}</span>
                            <span className="vy-mono" style={{ textAlign: "right" }}>{r.amt}</span>
                            <span className="vy-mono" style={{ fontSize: 9, padding: "3px 6px", background: c.bg, color: c.fg, textAlign: "center", borderRadius: 2 }}>{r.status}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
